//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { server } from "@/services/constants";
import api from "@/services/api";
import Hashids from "hashids";
import PDFCaseProgress from "@/utils/pdfClientTimeLine";

export default {
    name: "TimeLineOperations",
    props: {
        showReportInv: {
            type: Boolean,
            required: true
        },
        visible_check: {
            type: Boolean,
            required: true
        },
        module_name: {
            type: String,
            required: true
        },
        status_note: {
            type: String,
            required: true
        },
        modeOperations: {
            type: String,
            required: true
        },
        timelineStatus: {
            type: Number,
            required: true
        },
        timeline_case_id: {
            type: Number,
            required: true
        },
        showaddItem: {
            type: Object,
            default: () => ({})
        },
        statuslist: {
            type: Array,
            default: () => []
        },
        reportlist: {
            type: Array,
            default: () => []
        },
        showStatusInputCard: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            localStatusNote: this.status_note,
            encodedid: "",
            snackbar: false,
            snackbarText: "",
            snackbarColor: "success",
            tab: 1,
            visible: null,
            currentDateTime: '',
            caseWorkerName: '',
            selectedStatus: 0,
            dataCurrent: {},
            last_time: "",
            last_status: "",
            last_icon: "",
            last_icon_color: "",
            cssStatus: [
                {
                    status: "In Progress",
                    color: "#FFF7ED",
                    icon_color: "#D97706",
                    icon: "mdi-loading"
                },
                {
                    status: "Waiting for Client",
                    color: "#FEFCE8",
                    icon_color: "#CA8A04",
                    icon: "mdi-message-alert-outline"
                },
                {
                    status: "Waiting for Third Party",
                    color: "#ECFEFF",
                    icon_color: "#0891B2",
                    icon: "mdi-timer-sand"
                },
                {
                    status: "Internal Review",
                    color: "#EEF2FF",
                    icon_color: "#4F46E5",
                    icon: "mdi-clipboard-check-outline"
                },
                {
                    status: "Payment Pending",
                    color: "#FFF7ED",
                    icon_color: "#EA580C",
                    icon: "mdi-credit-card-outline"
                },
                {
                    status: "Completed",
                    color: "#F0FDF4",
                    icon_color: "#16A34A",
                    icon: "mdi-check-circle"
                },
                {
                    status: "On Hold",
                    color: "#FEF2F2",
                    icon_color: "#DC2626",
                    icon: "mdi-pause-circle"
                },
                {
                    status: "Cancelled",
                    color: "#F8FAFC",
                    icon_color: "#475569",
                    icon: "mdi-close-circle"
                },
                {
                    status: "Closed",
                    color: "#F0FDF4",
                    icon_color: "#15803D",
                    icon: "mdi-archive"
                }
            ],
            timelineData: [
                // {
                //     status: "In Progress",
                //     icon: "mdi-loading",
                //     icon_color: "#D97706",
                //     color: "#FFF7ED",

                //     status_time: "15/05/2026 09:30 AM",
                //     status_note: "Work on this request has started and is currently being processed by the assigned team.",
                //     worker: "testname user",
                //     visibility: true,
                // },

            ]
        };
    },
    async mounted() {
        await this.initPage();

    },
    watch: {
        timelineStatus: {
            immediate: true,
            handler(val) {
                this.handleTimelineStatus(val);
            }
        },
        status_note: {
            immediate: true,
            handler(val) {
                this.localStatusNote = val;
            }
        },
        localStatusNote(val) {
            this.$emit("update:status_note", val);
        },
        visible_check: {
            immediate: true,
            handler(val) {
                this.visible = val;
            }
        },
        visible(val) {
            this.$emit("update:visible_check", val);
        }
    },
    methods: {
        async initPage() {
            this.$showLoader();

            try {
                var mainid = `${this.timeline_case_id}`;
                const hashids = new Hashids("my-secret-salt", 8);
                const encoded = hashids.encode(mainid);
                this.encodedid = encoded;

                this.caseWorkerName = await this.getCaseWorkerName();
                this.currentDateTime = this.getCurrentDateTime();
                if (this.modeOperations == "Edit") {
                    await this.loaddataTimeline();
                    await this.loaddataTimelineVisibility();
                }

            } catch (err) {
                console.error(err);
            } finally {
                this.$hideLoader();
            }
        },

        async getCaseWorkerName() {
            let workerName = "";

            const userId = localStorage.getItem(server.USER_ID);

            const result = await api.getAccountByid(userId);

            if (result?.data?.length > 0) {
                workerName = result.data[0].name;
            }

            return workerName;
        },

        getCurrentDateTime() {
            const now = new Date();

            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const year = now.getFullYear();

            return `${day}/${month}/${year}`;
        },
        async copyLinkClientPreview() {
            try {
                this.$showLoader()
                const caseDetailResult = await api.getgetTimelineDataDetail({
                    params: {
                        module_name: this.module_name,
                        case_id: Number(this.timeline_case_id),
                    },
                });

                const caseInfo = { ...(caseDetailResult.data?.[0] || {}) };
                caseInfo.status = this.last_status;
                caseInfo.lastUpdated = this.last_time;

                const latestUpdate = {
                    message: this.dataCurrent?.status_note || '',
                    date: this.dataCurrent?.status_time || '',
                };

                const result = await PDFCaseProgress.createToPDF(
                    {
                        caseInfo,
                        latestUpdate,
                        timelineData: (this.timelineData || []).filter((item) => item.visibility === true),
                        caseId: this.timeline_case_id,
                        moduleName: this.module_name,
                    },
                    { open: false }
                );

                if (!result?.shortUrl) {
                    this.$hideLoader()
                    this.snackbarText = "สร้างลิงก์ไม่สำเร็จ ❌";
                    this.snackbarColor = "error";
                    this.snackbar = true;
                    return;
                }
                this.$hideLoader()
                await navigator.clipboard.writeText(result.shortUrl);
                this.snackbarText = "Copy สำเร็จ 🎉";
                this.snackbarColor = "success";
                this.snackbar = true;

            } catch (err) {
                this.$hideLoader()
                console.error("Copy failed:", err);
                this.snackbarText = "Copy ไม่สำเร็จ ❌";
                this.snackbarColor = "error";
                this.snackbar = true;
            }
        },
        previewClientPreview() {
            const localUrl = window.location.origin;

            const text = `${localUrl}/client-view/case/${this.encodedid}?module_name=${encodeURIComponent(this.module_name)}`;

            window.open(text, "_blank");
        },

        handleTimelineStatus(value) {
            if (Number(value) != 0) this.selectedStatus = String(value);
        },
        sendToParent(value) {
            // console.log(this.showaddItem.closed)

            const selectedItem = this.statuslist.find(
                item => Number(item.timeline_status_id) === Number(value)
            )

            this.$emit("timelineStatus", Number(value));
            if (this.module_name == "Corporate" || this.module_name == "Immigration") {
                this.$emit("requestStatus", selectedItem.module_id)
            } else {
                this.$emit("requestStatus", Number(selectedItem.module_id))
            }

        },
        async loaddataTimeline() {

            const result_timeline = await api.getgetClientTimelineHistoryShow({
                params: {
                    module_name: this.module_name,
                    case_id: Number(this.timeline_case_id),
                }
            })

            if (result_timeline.data && result_timeline.data.length > 0) {
                this.timelineData = result_timeline.data;
                this.last_time = result_timeline.data[0].status_time;
                this.last_status = result_timeline.data[0].status;
                this.last_icon = result_timeline.data[0].icon;
                this.last_icon_color = result_timeline.data[0].icon_color;
            }

        },
        async loaddataTimelineVisibility() {
            const result_timeline_visibility = await api.getgetClientTimelineHistoryShowVisibility({
                params: {
                    module_name: this.module_name,
                    case_id: Number(this.timeline_case_id),
                }
            })
            if (result_timeline_visibility.data && result_timeline_visibility.data.length > 0) {
                this.dataCurrent = result_timeline_visibility.data[0]
            }

        }
    }
};
